import React, { useState } from "react";
import ScrollToTop from "../ScrollToTop";
import TraningSection from "../Training Page Components/TrainingSection";
import Footer2 from "../Footer Components/Footer2";
import Navbar2 from "../Nav Components/Navbar2";
import Sidebar2 from "../Sidebar2";
import TrainingHero from "../Training Page Components/TrainingHero";

const TrainingPage = () => {
  const [isOpen, setIsOpen] = useState(false);

  const toggle = () => {
    setIsOpen(!isOpen);
  };
  return (
    <>
    <Sidebar2 isOpen={isOpen} toggle={toggle} />
      <ScrollToTop />
      <Navbar2 toggle={toggle} />
      <TrainingHero />
      <TraningSection />
      <Footer2 />
    </>
  );
};
export default TrainingPage;
